export default __webpack_public_path__ + "/assets/news-02.png";